import React, { useEffect, useState } from "react";
import { Phone } from "lucide-react";

// TODO: uzupełnić przez klienta (prawdziwy numer telefonu agenta)
const PHONE_DISPLAY = "+48 669 255 184";
const PHONE_TEL = "+48669255184";

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-cream/90 backdrop-blur-md border-b border-bordersoft shadow-sm"
          : "bg-cream/60 backdrop-blur-sm"
      }`}
    >
      <div className="container-narrow flex items-center justify-between h-16 md:h-20">
        <a
          href="#hero"
          data-testid="navbar-logo"
          className="flex items-center gap-2 group"
        >
          <span className="inline-flex items-center justify-center w-9 h-9 rounded-md bg-forest text-cream font-heading font-bold text-lg">
            JK
          </span>
          {/* TODO: uzupełnić przez klienta (nazwa firmy / imię i nazwisko agenta) */}
          <span className="font-heading font-semibold text-forest text-base md:text-lg hidden sm:inline">
            Jan Kowalski · Ubezpieczenia
          </span>
        </a>

        <div className="flex items-center gap-3">
          <a
            href={`tel:${PHONE_TEL}`}
            data-testid="navbar-phone-link"
            className="hidden sm:inline-flex items-center gap-2 text-forest font-medium hover:text-mustard-dark transition-colors text-sm md:text-base"
          >
            <Phone size={18} strokeWidth={2.2} />
            <span>{PHONE_DISPLAY}</span>
          </a>
          <a
            href="#kontakt"
            data-testid="navbar-cta-button"
            className="inline-flex items-center justify-center px-4 md:px-5 py-2.5 md:py-3 rounded-full bg-mustard hover:bg-mustard-dark text-white font-semibold text-sm md:text-base transition-colors min-h-[44px]"
          >
            <span className="sm:hidden inline-flex"><Phone size={18} /></span>
            <span className="hidden sm:inline">Umów konsultację</span>
          </a>
        </div>
      </div>
    </header>
  );
};

export default Navbar;
